import React from "react";
import { Link } from "react-router-dom";
import green_switch_ea from "../assets/images/green_switch_ea.png";
import purpledot from "../assets/images/purple_squre_dots.b6e7dbcc.svg";
import yellowdot from "../assets/images/yellow_squre_dots.a8deef14.svg";
import salary from "../assets/images/salary.png";
import loca from '../assets/images/loca.svg'
import company from '../assets/images/company.svg'
import spec from '../assets/images/spec.svg'
import ea1 from '../assets/images/ea1.svg'
import ea2 from '../assets/images/ea2.svg'
import ea3 from '../assets/images/ea3.svg'
import ea4 from '../assets/images/ea4.svg'
import ea5 from '../assets/images/ea5.svg'
import ea6 from '../assets/images/ea6.svg'
import ea7 from '../assets/images/ea7.svg'
import ea8 from '../assets/images/ea8.svg'
import s1 from '../assets/images/s1.png'
import s2 from '../assets/images/s2.png'
import s3 from '../assets/images/s3.png'



function EaAgentSalary() {
  return (
    <>
      <div className="overflow-hidden bg-placement-hero bg-cover w-full">
        <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
          <img src={green_switch_ea} alt="" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
          <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
            <div className="mx-auto lg:max-w-5xl">
              <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] mb-2 lg:leading-[56px]"><span className="block">Enrolled Agent</span><span className="block">Salary in India</span></h1>

              <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                    <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                        className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                    >
                        Enquiry Now
                    </Link>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>


      <div className="relative p-4 md:p-8 lg:p-10 pt-[91px] pb-[131px]">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0" style={{ transform: 'none' }}>
            <div className="mx-auto grid items-center xs:max-w-xl lg:max-w-5xl group h-full">
              <div className="flex flex-col ml-0 lg:ml-6">
                <h2 className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl text-center mt-4 lg:mt-0">
                  <span className="uppercase text-xl"> Career Prospects</span>
                  <span className="text-primary_text mt-3 mb-3">
                    Enrolled Agent (EA) Role</span>
                </h2>
                <p className="text-[15px] text-base md:text-medium text-center text-dark_text">
                  Enrolled Agents (EAs) are federally-authorized tax practitioners
                  empowered by the U.S. Department of the Treasury. They represent
                  taxpayers before the Internal Revenue Service (IRS) and provide
                  tax-related advice, compliance checks, and audits. EAs have broad
                  authority to handle tax issues for individuals, corporations,
                  estates, and more.
                </p>
              </div>
              <img className="w-[97%] mt-10 lg:ml-[3%]" src={salary} alt="" />
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div className="p-8 md:p-8 lg:p-10 bg-[#f5f9f3]">
        <div className="flex flex-col items-center">
          <h2 className="block mb-1 mt-4 text-2xl md:text-4xl font-bold text-gray-700  text-center">
            Enrolled Agent <span className="text-primary_text">Salary in India</span>
          </h2>
          <p className="lg:w-[60rem] mx-auto mt-3 mb-[41px] text-lg text-medium text-dark_text text-center">
            The salary of an Enrolled Agent in India varies significantly based on
            experience, location, and the hiring organization. Here’s a detailed
            look at the salary ranges:
          </p>
          <div tabindex="0 " className="">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-4xl mb-5">
              <div
                className="box transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden">
                  <div>
                    <div className="flex items-center h-auto lg:h-[33rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={s1}
                          alt="IRS Authorization"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          Entry-Level Salaries
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          Fresh EAs can expect an average starting salary ranging from INR 6 to 8 lakhs per annum.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="box  transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden">
                  <div>
                    <div className="flex items-center h-auto lg:h-[33rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={s2}
                          alt="Tax Gurus"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          Mid-Level Salaries
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          With 3-5 years of experience, EAs typically earn between INR 12 to 15 lakhs annually.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="box  transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden">
                  <div>
                    <div className="flex items-center h-auto lg:h-[33rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={s3} alt="Representation and Tax Troubleshooters"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          Senior-Level Salaries
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          Experienced EAs with over 5 years in the field can earn INR 20 lakhs or more, especially if employed by top firms like the Big 4 (Deloitte, PwC, EY, KPMG).
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative lg:py-1 lg:px-10 lg:py-0 pt-[71px] pb-[111px] px-6">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">
                  <span className="uppercase text-xl">Factors Influencing</span>
                </h2>
                <h2 className="mt-2 block text-2xl md:text-4xl font-bold text-primary_text">
                  Enrolled Agent Salary
                </h2>
              </div>
            </div>
          </div>
          <div className="lg:max-w-3xl px-4 py-6 justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center items-center">
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(255, 247, 235)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                1
                              </h3>
                              <img className="w-16 h-16" src={loca} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Location
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Salaries in metropolitan areas are generally higher
                          due to the cost of living and demand.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(245, 249, 243)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                2
                              </h3>
                              <img className="w-16 h-16" src={company} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Company
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Working with renowned firms often offers higher pay
                          and better career growth opportunities.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                3
                              </h3>
                              <img className="w-16 h-16" src={spec} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Specialization
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          EAs with expertise in niche areas like international
                          tax or corporate tax advisory can command higher
                          salaries.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div className="lg:py-1 lg:px-10 py-0 px-6 mt-[-31px]">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">
                  <span className="uppercase text-xl">Career Prospects</span>
                </h2>
                <h2 className="mt-2 block text-2xl md:text-4xl font-bold text-primary_text">
                  for Enrolled Agents
                </h2>
                <p className="mt-4 text-md text-medium text-dark_text font-light">
                  Becoming an EA opens up various high-profile job opportunities
                  in both the private and public sectors:
                </p>
              </div>
            </div>
          </div>
          <div className="lg:max-w-5xl px-4 py-6 justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-center items-center">
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(255, 247, 235)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                1
                              </h3>
                              <img className="w-16 h-16" src={ea1} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Tax Consultant
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Provides expert advice on complex tax matters,
                          international tax planning, mergers, and acquisitions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(245, 249, 243)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                2
                              </h3>
                              <img className="w-16 h-16" src={ea2} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Tax Preparer
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Manages tax return preparations for individuals and
                          businesses, ensuring compliance with tax laws.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                3
                              </h3>
                              <img className="w-16 h-16" src={ea3} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              IRS Representative
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Acts as a liaison between taxpayers and the IRS,
                          handling audits, disputes, and negotiations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                4
                              </h3>
                              <img className="w-16 h-16" src={ea4} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Corporate Tax Advisor
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Advises corporations on tax strategies to minimize
                          liabilities and enhance tax efficiency.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                5
                              </h3>
                              <img className="w-16 h-16" src={ea5} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Estate and Trust Tax Specialist
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Manages tax-related issues for trusts and estates,
                          ensuring compliance and efficient asset transition.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                6
                              </h3>
                              <img className="w-16 h-16" src={ea6} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Small Business Tax Specialist
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Focuses on tax planning and compliance for small
                          businesses, helping them grow while adhering to tax
                          regulations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                7
                              </h3>
                              <img className="w-16 h-16" src={ea7} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Tax Compliance Officer
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Ensures that organizations comply with all tax laws
                          and regulations through regular audits and reviews.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                tabindex="0"
                className=" transform transition-transform duration-300 hover:scale-110"
              >
                <div
                  className="group flex flex-col h-[16rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                  href="#"
                  style={{ backgroundColor: "rgb(235, 243, 248)" }}
                >
                  <div
                    className="relative overflow-hidden"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ opacity: "1", transform: "none" }}>
                      <div className="p-6 flex-grow">
                        <div className="flex items-start">
                          <div className="grow flex flex-col items-start">
                            <div className="w-full flex flex-row items-center justify-between">
                              <h3 className="text-[3rem] font-semibold text-primary_text">
                                8
                              </h3>
                              <img className="w-16 h-16" src={ea8} alt="" />
                            </div>
                            <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                              Forensic Accountant
                            </h3>
                          </div>
                        </div>
                        <p className="text-xs font-light mr-5">
                          Investigates financial discrepancies and fraud,
                          providing expert testimony in legal proceedings.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#512A99] px-6 py-10 bg-center bg-no-repeat bg-cover mb-4">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="text-white text-2xl">The role of an Enrolled Agent is both prestigious and
                  rewarding, offering diverse career paths and competitive
                  salaries in India</h2>
                <p className="mt-4 text-md text-medium text-white text-[16px]">
                  As the demand for skilled tax professionals
                  grows, EAs are well-positioned to leverage their expertise for
                  career advancement and financial success. For those looking to
                  pursue this certification, enrolling in comprehensive EA
                  courses can be a significant step towards achieving these
                  career goals.
                </p>
                <p className="mt-8 text-md text-medium text-white  text-[16px]">
                  <span className="bg-white inline-block text-[#512A99] text-xl p-3 mt-2 rounded-xl font-semibold">For more detailed insights and up-to-date information, visit
                  <a href="https://www.kcglobed.com/"> KC GlobEd.</a></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
export default EaAgentSalary;
